
<div class="mt-2 mb-2">
  <div class="label mt-4 mb-1">Assigned To</div>
  <div class="d-flex align-items-center" :class="{ 'cursor-pointer': !disabled }" v-if="user" id="assignUser">
    <div class="avatar text-uppercase">
      {{ user.shortName.substr(0, 3) }}
    </div>
    <div class="ml-2">{{ user.firstName }}</div>
  </div>

  <div class="d-flex align-items-center" :class="{ 'cursor-pointer': !disabled }" v-else id="assignUser">
    <div class="avatar text-uppercase">N/A</div>
    <div class="ml-2">unassigned</div>
  </div>

  <b-popover target="assignUser" ref="assignUser" :disabled="disabled" triggers="click blur">
    <div class="label mt-1 mb-1 d-flex align-items-center justify-content-center">Assign User</div>
    <hr class="mt-2 mb-2" />
    <input type="text" v-model="filter" class="form-control mb-2 mt-1" placeholder="Filter..." />

    <div class="bi-label-container">
      <div class="user-entry remove mb-2" @click="assignUser(null)" v-if="user">
        <div class="avatar text-uppercase">N/A</div>
        <div class="ml-2">Remove assignment</div>
      </div>

      <div v-for="user in filteredUsers" :key="user.id" class="mb-2">
        <div class="user-entry" @click="assignUser(user)">
          <div class="avatar text-uppercase">
            {{ user.shortName.substring(0, 3) }}
          </div>
          <div class="ml-2">{{ user.firstName + ' ' + user.lastName }}</div>
        </div>
      </div>
    </div>
  </b-popover>
</div>
